const OrbitSession = (() => {
  const SESSION_NAME = 'orbit_session'
  const TTL = 7 // days
  let SessionWriter = null

  const get = (key) => {
    return SessionWriter.get(key)
  }
  const set = (obj) => {
    for (const [key, val] of Object.entries(obj)) {
      SessionWriter.set(key, val)
    }
  }
  const del = (key) => {
    return SessionWriter.del(key)
  }

  const delAll = () => {
    return SessionWriter.delAll()
  }

  const CookieWriter = {
    set: (key, val) => {
      setCookieParam(key, val, TTL)
    },
    get: (key) => {
      return getCookieParam(key)
    },
    del: (key) => {
      deleteCookieParam(key)
    },
    delAll: () => {
      deleteAllCookieParams()
    }
  }

  const LocalStorageWriter = {
    set: (key, val) => {
      setLocalStorageParam(key, val)
    },
    get: (key) => {
      return getLocalStorageParam(key)
    },
    del: (key) => {
      deleteLocalStorageParam(key)
    }
  }

  const getSessionWriter = (storeType) => {
    switch (storeType.toLowerCase()) {
      case 'cookie':
        return CookieWriter
      case 'localstorage':
        return LocalStorageWriter
      default:
        break
    }
  }

  const setStoreType = (storeType) => {
    if (
      !['memory', 'cookie', 'localstorage', 'sessionstorage'].includes(
        storeType.toLowerCase()
      )
    ) {
      throw new Error('Unknown store type')
    }

    SessionWriter = getSessionWriter(storeType)
  }

  setStoreType('cookie')

  const getUpdatedTime = (numOfDays) => {
    const now = new Date()
    now.setTime(now.getTime() + numOfDays * 24 * 60 * 60 * 1000)
    return now.toUTCString()
  }

  const getCookie = (cookieName) => {
    const name = `${cookieName}=`
    const decodedCookie = decodeURIComponent(document.cookie)
    const cookies = decodedCookie.split(';')

    try {
      for (let cookie of cookies) {
        while (cookie.charAt(0) === ' ') {
          cookie = cookie.substring(1)
        }

        if (cookie.indexOf(name) === 0) {
          return cookie.substring(name.length, cookie.length)
        }
      }
    } catch (er) {
      return '{}'
    }
  }

  const getCookieParam = (key) => {
    const ifCookieExist = getCookie(SESSION_NAME)
    if (ifCookieExist) {
      const cookies = JSON.parse(getCookie(SESSION_NAME))
      if (Object.hasOwnProperty.bind(cookies)(key)) {
        return cookies[key]
      } else {
        return undefined
      }
    } else return undefined
  }

  const setCookieParam = (key, val, TTL) => {
    const expiry = `expires=${getUpdatedTime(TTL)}`
    const existingCookie = getCookie(SESSION_NAME)
    let cookieJson = {}

    if (existingCookie) {
      cookieJson = JSON.parse(existingCookie)
    }

    cookieJson[key] = val

    let cookieStr = `${SESSION_NAME}=${JSON.stringify(cookieJson)};`
    cookieStr += `${expiry};path=/`
    document.cookie = cookieStr
  }

  const deleteCookieParam = (key) => {
    const expiry = `expires=${getUpdatedTime(TTL)}`
    const existingCookie = getCookie(SESSION_NAME)
    let cookieJson = {}

    if (existingCookie) {
      cookieJson = JSON.parse(existingCookie)
      delete cookieJson[key]
    }

    let cookieStr = SESSION_NAME + '=' + JSON.stringify(cookieJson) + ';'
    cookieStr += expiry + ';path=/'
    document.cookie = cookieStr
  }

  const deleteAllCookieParams = () => {
    const defaultCookie = { default: 'cookie', provider: 'UL' }
    document.cookie =
      SESSION_NAME + '=' + JSON.stringify(defaultCookie) + ';path=/'
  }

  const getLocalStorageParam = (key) => {
    const value = localStorage.getItem(key)
    return value ?? undefined
  }

  const setLocalStorageParam = (key, val) => {
    localStorage.setItem(key, val)
  }

  const deleteLocalStorageParam = (key) => {
    if (localStorage.getItem(key)) {
      localStorage.removeItem(key)
    }
  }

  return {
    get,
    set,
    del,
    delAll,
    setStoreType
  }
})()

export default OrbitSession
